import { render, staticRenderFns } from "./toAndFormNh1.vue?vue&type=template&id=6233e71e&scoped=true"
import script from "./toAndFormNh1.vue?vue&type=script&lang=js"
export * from "./toAndFormNh1.vue?vue&type=script&lang=js"
import style0 from "./toAndFormNh1.vue?vue&type=style&index=0&id=6233e71e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6233e71e",
  null
  
)

export default component.exports